import React, { useEffect, useState } from "react";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min.js";
import jwt_decode from "jwt-decode";
import apiConfig from "../apiConfig";
import axios from "axios";

const Rebate_commission = () => {
  let history = useHistory();

  // Token decode
  const token = localStorage.getItem("jwtToken");
  const decodedToken = token ? jwt_decode(token) : null;

  // States
  const [userIds, setUserIds] = useState([]); 
  const [userCount, setUserCount] = useState(0); 
  const [loadingUsers, setLoadingUsers] = useState(false); 
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    getAllUser();
  }, []);

  // Backend থেকে সব user আনছি
  const getAllUser = async () => {
    try {
      setLoadingUsers(true);
      const res = await axios.get(`${apiConfig.baseURL}/api/admin/all_user_list`);

      setUserIds(res.data.ids || []);
      setUserCount(res.data.total || 0);
    } catch (error) {
      console.error("Error fetching user list:", error);
      alert("Failed to fetch users!");
    } finally {
      setLoadingUsers(false);
    }
  };

  // Distribute button click
  const addinpdata = async (e) => {
    e.preventDefault();

    if (userIds.length === 0) {
      alert("No users found!");
      return;
    }

    try {
      setSubmitting(true);
      const res = await axios.post(`${apiConfig.baseURL}/api/admin/Rebate_commission`, {
        all_user_ids: userIds,
      });
      console.log(res.data);
      if (res.status === 200) {
        alert(`Rebet Commission distributed to users successfully!`);
        history.push("/rebate-list");
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        alert("Unauthorized or invalid input!");
      } else {
        console.error("Error creating rebate commission:", error);
        alert("Something went wrong!");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />
      <Chatbox />
      <HeaderRight />
      <LeftSidebar />

      <div className="content-body">
        <div className="container-fluid">
          <div className="col-lg-8 offset-lg-2">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Rebate Commission</h4>
                <Link to="/rebate-list">
                  <button type="button" className="btn btn-success float-right">
                    Rebate Commission
                  </button>
                </Link>
              </div>

              <div className="card-body">
                <div className="basic-form">
                  <form>
                    {/* Show total users */}
                    <div className="mb-3 row">
                      <label className="col-sm-4 col-form-label">Total Users</label>
                      <div className="col-sm-8">
                        <p className="form-control-plaintext">
                          {loadingUsers ? "Loading..." : userCount}
                        </p>
                      </div>
                    </div>

                    {/* Distribute button */}
                    <div className="mb-3 row">
                      <div className="col-sm-10">
                        <button
                          type="submit"
                          name="send"
                          onClick={addinpdata}
                          className="btn btn-primary"
                          disabled={loadingUsers || submitting}
                        >
                          {submitting ? "Distributing..." : "Distribute Now"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Rebate_commission;
